import React, { Component } from "react";
import ReactGA from "react-ga4";
export default class BuyTicket extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }
  handleClick() {
    ReactGA.event({
      category: "keno_2024",
      action: "click",
      label: "buy ticket",
    });
  }
  render() {
    const { language } = this.props;
    return (
      <div className="buyTicket">
        <a
          className="button button--red"
          href={`https://www.eestiloto.ee/${
            language !== "et" ? "ru" : "et"
          }/keno/#plain`}
          onClick={() => this.handleClick()}
        >
          <div className="background"></div>
          {language === "et" ? (
            <span> OSTAN&nbsp;PILETI</span>
          ) : (
            <span>Купить&nbsp;билет</span>
          )}
        </a>
      </div>
    );
  }
}
